// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__khiqi","title":"SideMenu_title__HegSO","divider":"SideMenu_divider__i-rUd","button":"SideMenu_button__euSk6"};